<template>
  <div>
    <template v-if="fetchState.pending">
      <div>loading...</div>
    </template>
    <template v-else-if="fetchState.error">
      <ErrorPageLayout :error="fetchState.error" />
    </template>
    <template v-else>
      <div>
        <div class="sm:sticky top-[-16px] z-3" :class="{ bilpopHeader: currentTab === 'bilpop', emojileHeader: currentTab === 'emojile' }">
          <LeaderboardHeader v-if="!isMobile" :current-tab="currentTab" />
          <div>
            <PreviousGamesTab :current-tab="currentTab" />
          </div>
        </div>
        <div class="bg-white flex items-center justify-start">
          <OBreadcrumb
            v-if="isMobile"
            class="capitalize text-md leading-18 text-[#161616] ml-6 my-4"
            :items="breadcrumbRoutes"
            show-home-page-title
          />
        </div>

        <div class="max-w-[1300px] w-full mx-auto justify-between flex flex-col sm:flex-row items-center sm:items-start">
          <Leaderboard :current-game="currentTab" />
          <div v-if="!isMobile" class="mb-5 z-2 sticky top-[130px]">
            <DailyBilpop v-if="currentTab === 'bilpop'" cancel-sticky />
            <DailyEmojile v-if="currentTab === 'emojile'" cancel-sticky />
            <InfoCard v-if="!isMobile" :current-tab="currentTab" />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent, useRoute, computed, useContext, useFetch } from '@nuxtjs/composition-api';
import ErrorPageLayout from '@/modules/common/components/layout/ErrorPageLayout.vue';
import LeaderboardHeader from '@/modules/oyun/components/leaderboard/LeaderboardHeader.vue';
import PreviousGamesHeader from '~/modules/oyun/components/previousGames/PreviousGamesHeader.vue';
import CardList from '~/modules/oyun/components/previousGames/CardList.vue';
import { OBreadcrumb } from '~/modules/common/components/ui';
import { useDevice } from '~/composables/useDevice';
import { IS_ONEDIO } from '~/constants/config';
import DailyBilpop from '~/modules/oyun/components/previousGames/DailyBilpop.vue';
import DailyEmojile from '~/modules/oyun/components/previousGames/DailyEmojile.vue';
import PreviousGamesTab from '~/modules/oyun/components/previousGames/PreviousGamesTab.vue';
import Leaderboard from '~/modules/oyun/components/leaderboard/Leaderboard.vue';
import InfoCard from '~/modules/oyun/components/leaderboard/InfoCard.vue';
import { useGameMeta } from '~/modules/oyun/utils/gameMeta';

export default defineComponent({
  components: {
    ErrorPageLayout,
    PreviousGamesHeader,
    CardList,
    OBreadcrumb,
    DailyBilpop,
    DailyEmojile,
    PreviousGamesTab,
    LeaderboardHeader,
    Leaderboard,
    InfoCard,
  },
  head: {
    bodyAttrs: {
      class: 'bg-[#f7f8fb] o-ps-global',
    },
  },
  props: {
    isWebview: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const route = useRoute();
    const { isMobile } = useDevice();
    const currentTab = route.value.params.slug;
    const { redirect, $cache } = useContext();
    $cache('public, max-age=30');
    const breadcrumbRoutes = computed(() => {
      return [
        { href: `${props.isWebview ? '/mobile' : ''}/${currentTab}`, name: currentTab },
        { href: route.value.fullPath, name: 'Sıralamalar' },
      ];
    });
    const { fetchState } = useFetch(() => {
      if (currentTab !== 'emojile' && currentTab !== 'bilpop') redirect('/oyun/leaderboard/bilpop');
    });
    if (!IS_ONEDIO) {
      redirect('/');
    }

    // META
    useGameMeta({ path: `/leaderboard/${currentTab}` });
    return { isMobile, currentTab, breadcrumbRoutes, IS_ONEDIO, fetchState };
  },
});
</script>

<style scoped lang="scss">
.bilpopHeader {
  background: linear-gradient(166deg, #400677 -6.27%, #6e2fbf 100%);
}

.emojileHeader {
  background: linear-gradient(166deg, #00084d -6.27%, #2c4389 106.87%);
}
</style>
